// extracted by mini-css-extract-plugin
export default {"price":"D1-z","onSale":"E1-z","msrpLabelPrice":"F1-z","originalPrice":"G1-z","msrpLabel":"H1-z","percentOff":"I1-z"};